function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFirefox = function SvgFirefox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "firefox_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1024v1024H0z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M512.04 85.33c235.65 0 426.67 191.02 426.67 426.67S747.69 938.67 512.04 938.67 85.38 747.65 85.38 512c0-62.42 13.4-121.77 37.55-175.19 19.88-40.06 52.61-79.96 78.93-93.61-27.86 54.74-41.51 108.37-44.37 144.34 19.37-64 56.11-117.63 107.52-155.48 88.15-64.81 206.85-67.71 254.12-26.45-87.72 30.17-183.3 151.38-162.26 293.38a228.31 228.31 0 0 0 20.86 67.5c-16.38-43.09-17.83-103.81 8.62-143.27 29.53-43.95 71.59-53.25 94.12-48.47-8.87-1.88-28.5 35.67-31.4 42.28a128.04 128.04 0 0 0-10.71 53.33 145.09 145.09 0 0 0 43.95 101.55c82.01 79.83 214.31 48.43 273.54-42.75 40.7-62.76 45.65-169.3-6.57-253.95a298.459 298.459 0 0 0-46.25-56.32c-78.93-75.35-191.15-109.65-297.9-94.08-47.19 7.57-87.35 21.16-120.49 40.79 46.29-46.21 138.28-80.26 227.41-80.26Z",
    style: {
      clipPath: "url(#firefox_svg__a)"
    }
  }));
};
export default SvgFirefox;